<div id="client-auth-details">
    <span id="subtitle">Client authorization details</span>
    <div class="row">
        <div class="col0" *ngIf="this.isAccountHolderSelected">
            <mm-label-group id="confirmationPage_useEauthorizationLabel" [title]="labels.useEAuth" [data]="eAuthSelection"></mm-label-group>
        </div>
        <div class="col1">
            <div *ngIf="eAuthInfo.isAccountHolderSelected" class="label-group" >
                <span class="label" data-testid="accountDetailsLabel">{{labels.accountDetails}}</span>
                <div *ngFor="let nameAndEmail of accountHolderNameAndEmail" data-testid="confirmationPage_useEauthorizationAccountDetails">
                    <span attr.data-testid="confirmationPage_useEauthAccountDetailsName{{nameAndEmail['name']}}">{{nameAndEmail['name'] | name}}</span>
                    <br>
                    <span attr.data-testid="confirmationPage_useEauthAccountDetailsEmail{{nameAndEmail['name']}}">{{nameAndEmail['email']}}</span>
                </div>
            </div>
            <div class="col2"  *ngIf="!this.isAccountHolderSelected">
                <mm-label-group id="confirmationPage_useEauthorizationLabel"  class="pend-reason-text"  [data]="prefilledText"></mm-label-group>
                
            </div>
           
        </div>
        
    </div>
</div>
<sdps-divider *ngIf="!this.isAccountHolderSelected && !useCondensedLayout" variation="secondary"></sdps-divider>

